import React from 'react';
export function TestimonialSection() {
  return <div className="max-w-4xl mx-auto mb-12" data-id="element-389">
      <div className="text-center mb-6" data-id="element-390">
        <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-2" data-id="element-391">
          Lo Que Dicen Nuestros Estudiantes
        </h2>
        <p className="text-xl text-gray-600" data-id="element-392">Testimonios Reales</p>
      </div>
      <div className="relative w-full overflow-hidden shadow-lg" style={{
      padding: '59.67% 0 0 0',
      position: 'relative'
    }} data-id="element-393">
        <iframe src="https://player.vimeo.com/video/1175309646?badge=0&autopause=0&player_id=0&app_id=58479" frameBorder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerPolicy="strict-origin-when-cross-origin" style={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%'
      }} title="Recap Testimonio Zoom Actualizado" data-id="element-394"></iframe>
      </div>
    </div>;
}